<template lang="pug">
.import-data
  y-dialog(v-model="showModal" max-width="600px" persistent scrollable :fullscreen="step == 0? false : $vuetify.breakpoint.xsOnly")
    v-card(min-height="80vh")
      v-card-title.px-4
        v-layout
          eva-icon.mr-4(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" @click="showModal = false")
          .h6.textColor--text Import data
      v-card-text.px-4
        //- y-stepper.mb-8(:currentStep="step" :steps="steps")
        v-window.px-2.mt-8(v-model="step")
          v-window-item(:value="1")
            v-form(ref="form1")
              .p1.primary500--text Import income or expense data from your previous accounting system in 3 steps:
              .s2.primary500--text.mt-2 1. Download a template
              .s2.primary500--text 2. Fill in the template with your data
              .s2.primary500--text 3. Upload the completed file

              v-card.pa-4.mt-4(flat outlined)
                .h6 Income
                .s1.mt-2 Download template
                .c1.mt-2 Fill in this template with your income records.
                v-btn.px-2.mt-4(color="info500" outlined small depressed :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}" @click="clickSampleCSV('incomes')")
                  .button-AA-small.info500--text download income template
                
                .s1.mt-6 Upload your completed income file
                .c1.primary400--text Please save your file as .csv
                v-row.d-flex.mt-4(no-gutters)
                  v-file-input.mr-2(v-model="form.incomeFile" outlined show-size accept=".csv" prepend-icon="" placeholder="No file selected" background-color="basic200" dense :rules="uploadFiles.length > 0? [] : rules.document")
                  .file-layout
                    v-btn(depressed color="primary500" outlined height="40" style="background-color: var(--v-basic600T08)") 
                      .button-AA-small.primary500--text browse
                    input.input-layout(type="file" @change="onIncomeFileChange" accept=".csv" style="width: 90px !important; height:40px !important;")
              
              v-card.pa-4.mt-4(flat outlined)
                .h6 Expense
                .s1.mt-2 Download template
                .c1.mt-2 Fill in this template with your expense records.
                v-btn.px-2.mt-4(color="info500" outlined small depressed :style="{'background-color':$vuetify.theme.themes[$theme].infoT08}" @click="clickSampleCSV('expenses')")
                  .button-AA-small.info500--text download expense template
                
                .s1.mt-6 Upload your completed expense file
                .c1.primary400--text Please save your file as .csv
                v-row.d-flex.mt-4(no-gutters)
                  v-file-input.mr-2(v-model="form.expenseFile" outlined show-size accept=".csv" prepend-icon="" placeholder="No file selected" background-color="basic200" dense :rules="uploadFiles.length > 0? [] : rules.document")
                  .file-layout
                    v-btn(depressed color="primary500" outlined height="40" style="background-color: var(--v-basic600T08)") 
                      .button-AA-small.primary500--text browse
                    input.input-layout(type="file" @change="onExpenseFileChange" accept=".csv" style="width: 90px !important; height:40px !important;")

          v-window-item(:value="2")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            v-form(v-else ref="form2")
              .p1.primary500--text Review and match the columns of your CSV to the specified YezzaBooks fields.
              .table.mt-6.mx-n6
                v-divider.basic300
                v-layout
                  div.py-2.px-6(style="width:170px")
                    .label.primary400--text.text-uppercase YEZZABOOKS FIELDS
                  v-divider.basic300(vertical)
                  div.py-2.px-6
                    .label.primary400--text.text-uppercase CSV column headers
                v-divider.basic300
                template(v-for="(field, index) in fields")
                  v-layout(:key="'field' + field.name")
                    div.py-2.px-6(style="min-width:170px")
                      .s1.primary500--text {{ field.name }}
                    v-divider.basic300(vertical)
                    div.py-1
                      v-select.my-2.px-6(v-model="fields[index].col_index" background-color="basic200" outlined dense hide-no-data hide-details :items="headers" item-text="display_name" item-value="col_index" placeholder="Select column" :rules="field.required ? rules.is_selected : []")
                        template(v-slot:append)
                          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-divider.basic300
          v-window-item(:value="3")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            v-form(v-else ref="form3")
              .p1.primary500--text {{ $tc('transactions', transactions.length) }} will be imported.
              .table.mt-6.mx-n6
                v-simple-table(fixed-header dark)
                  template(v-slot:default)
                    thead
                      tr
                        th.text-left(:style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }")
                          v-row.d-flex(align='center')
                            div.mx-2.mr-4(style="height:20px; width:20px")
                              y-checkbox
                            .label.primary500--text.text-uppercase {{ fields[0].name }}
                        th.text-left.s2.primary500--text.text-uppercase(v-if="index != 0" v-for="(field, index) in fields" :key="'head' + field.name" :style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }") {{ field.name }}
                    tbody.basic100
                      tr(v-for="(field, index) in fields" :key="'body' + field.name")
                        td.py-2
                          v-row.d-flex(align='center')
                            div.mx-2.mr-4(style="height:20px; width:20px")
                              y-checkbox
                            div.p2.default--text {{ field.name }}
                        td.py-2
                          div.p2.default--text {{ field.name }}
                        td.py-2
                          div.p2.default--text {{ field.name }}
          v-window-item(:value="4")
            v-layout.text-center
              v-col
                .h6.textColor--text Import Completed
                eva-icon.my-4(name="checkmark-circle-2-outline" width="60" height="60" :fill="$vuetify.theme.themes[$theme].success500")
                .p1 (Next step? You can find them here:)
      v-divider.basic300
      v-card-actions
        v-spacer
        v-btn(v-if="step != 4" color='white' text @click="showModal = false")
          .button-Aa-medium.primary400--text Close
        v-btn(color="info500" dark @click="nextStep" depressed height=32 :loading="isLoading")
          .button-AA-medium.basic100--text {{ steps[step].button }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ImportDataDialog from '@/components/yezzabook/dialogs/ImportDataDialog.vue'

export default {
  name: "ImportDataDialog",
  components: { ImportDataDialog },
  props: ['open'],
  data: () => ({
    dataType: 'incomes',
    dataTypes: [
      { name: 'Income', id: 'incomes'},
      { name: 'Expense', id: 'expenses'}
    ],
    form: {
      incomeFile: null,
      expenseFile: null,
      document: null,
      mappedData: {
        document_hid: null,
        skip_first_row: true,
        fields: []
      }
    },
    isFetching: false,
    isLoading: false,
    headers: [],
    fields: [],
    transactions: [],
    selectedTransactions: [],
    step: 1,
    steps: [
      { title: '', button: 'Next', hidden: true},
      { title: 'Upload', button: 'Next', hidden: false},
      { title: 'Match Fields', button: 'Next', hidden: false},
      { title: 'Import', button: 'Import', hidden: false},
      { title: '', button: 'Finish', hidden: true}
    ],
    rules: {
      document: [val => (val || '').length > 0 || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    uploadFiles () {
      let files = []
      if (this.form.incomeFile) {
        files.push({type: 'incomes', document: this.form.incomeFile})
      }
      if (this.form.expenseFile) {
        files.push({type: 'expenses', document: this.form.expenseFile})
      }
      return files
    }
  },
  // watch: {
  //   dataType () {
  //     this.fetchFields()
  //   }
  // },
  mounted () {
    // this.fetchFields()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSampleCSV (type) {
      const url = `https://cdn.yezza.io/yezzabooks/import_templates/import_templates/yezza_books_${type}_import.csv`
      window.open(url, '_blank')
    },
    nextStep () {
      if (this.step === 1) {
        if (!this.$refs.form1.validate()) {
          return
        }
        this.uploadCsv()
      } else if (this.step === 2) {
        if (!this.$refs.form2.validate()) {
          this.showMessage(['error', this.$t('error_message.please_select_required_column')])
          return
        }
        this.mapCSV()
      } else if (this.step === 4) {
        this.showModal = false
        location.href = `/admin/yezza-book/${this.dataType}`
      }
    },
    fetchFields () {
      this.$axios.get(`/books/${this.company.slug}/${this.dataType}/import_csv`)
        .then(resp => {
          this.fields = resp.data.fields
        }).catch(() => {})
    },
    async uploadCsv() {
      this.isLoading = true
      await this.asyncForEach(this.uploadFiles, async (file) => {
        try {
          var params = new FormData()
          params.append('file', file.document)
          await this.$axios.post(`/books/${this.company.slug}/${file.type}/import_csv`, params)
          this.dataType = file.type
        } catch (error) {
          console.log(error)
        }
      })
      this.step = 4
      this.isLoading = false
    },
    uploadDocument () {
      this.isLoading = true
      var params = new FormData()
      params.append('file', this.form.document)
      this.$axios.post(`/documents/`, params)
        .then(resp => {
          this.step++
          this.isFetching = true
          this.form.mappedData.document_hid = resp.data.hid
          this.$axios.get(`/documents/${this.form.mappedData.document_hid}/csv_headers`)
            .then(resp => {
              this.isFetching = false
              this.headers = resp.data.map((header, index) => { 
                return {
                  display_name: `Column ${index + 1}: ${header}`,
                  name: header,
                  col_index: index
                }
              })
            }).catch(() => {})
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    mapCSV () {
      this.isLoading = true
      this.form.mappedData.fields = this.fields
      this.$axios.post(`/books/${this.company.slug}/customers/import_csv`, this.form.mappedData)
        .then(resp => {
          this.transactions = resp.data
          this.step++
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_match_data')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onIncomeFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.form.incomeFile = files[0]
    },
    onExpenseFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.form.expenseFile = files[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
div >>> .v-file-input >>> fieldset {
  border-color: var(--v-primary200);
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
tbody tr:hover {
  background-color: transparent !important;
}
.theme--dark.v-data-table thead tr:last-child th, 
.theme--dark.v-data-table tbody tr:not(:last-child) td:last-child,
.theme--dark.v-data-table tbody tr td,
.theme--dark.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) {
  border-bottom: 1px solid var(--v-basic300) !important;
}
</style>

<i18n>
{
  "en": {
    "transactions" : "No transaction| {n} transaction | {n} transactions"
  }
}
</i18n>